/* Accès restreint : seules l'accueil, les pages produit et le panier sont
   ouvertes. Toute autre page du thème renvoie vers l'accueil.
   Les routes gérées par Shopify (caisse, mot de passe, captcha, politiques
   légales) restent accessibles, sinon plus personne ne peut payer.
   Désactivé dans l'éditeur de thème pour pouvoir continuer à tout modifier. */
(function () {
  'use strict';

  if (window.Shopify && window.Shopify.designMode) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var path = window.location.pathname;
  if (root !== '/' && path.indexOf(root) === 0) path = '/' + path.slice(root.length);
  else if (root !== '/' && path === root.replace(/\/$/, '')) path = '/';

  var allowed = [
    /^\/$/,
    /^\/products\//,
    /^\/collections\/[^/]+\/products\//,
    /^\/cart(\/|$)/,
    /^\/checkouts?(\/|$)/,
    /^\/password(\/|$)/,
    /^\/challenge(\/|$)/,
    /^\/discount\//,
    /^\/policies\//
  ];

  for (var i = 0; i < allowed.length; i++) {
    if (allowed[i].test(path)) return;
  }

  window.location.replace(root);
})();

(function () {
  'use strict';

  var STATES = ['pre-drop', 'early', 'public', 'sold-out'];
  var INVENTORY_POLL_MS = 45000;

  function parseTimestamp(value) {
    var n = parseInt(value, 10);
    return isNaN(n) || n <= 0 ? null : n;
  }

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function setUnit(countdown, unit, value) {
    var el = countdown.querySelector('[data-drop-unit="' + unit + '"]');
    if (el && el.textContent !== value) {
      el.textContent = value;
    }
  }

  function updateCountdowns(root, targetSeconds) {
    var totalSeconds = Math.max(0, Math.floor(targetSeconds - Date.now() / 1000));
    var values = {
      days: pad(Math.floor(totalSeconds / 86400)),
      hours: pad(Math.floor((totalSeconds % 86400) / 3600)),
      minutes: pad(Math.floor((totalSeconds % 3600) / 60)),
      seconds: pad(totalSeconds % 60)
    };

    root.querySelectorAll('[data-drop-countdown]').forEach(function (countdown) {
      Object.keys(values).forEach(function (unit) {
        setUnit(countdown, unit, values[unit]);
      });
    });
  }

  function applyState(root, state) {
    if (root.dataset.dropCurrentState === state) return;
    root.dataset.dropCurrentState = state;
    STATES.forEach(function (s) {
      root.classList.toggle('is-' + s, s === state);
    });
    root.dispatchEvent(new CustomEvent('dropstatechange', { detail: { state: state }, bubbles: true }));
  }

  function fetchAvailability(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (product) { return product ? !!product.available : null; })
      .catch(function () { return null; });
  }

  function initRoot(root) {
    var early = parseTimestamp(root.dataset.early);
    var publicTs = parseTimestamp(root.dataset.public);
    var handle = root.dataset.productHandle;
    // null = inventory unknown yet; treated as available so the UI never
    // flashes sold-out before the first /products/<handle>.js response lands.
    var available = null;

    function evaluate() {
      var nowSeconds = Date.now() / 1000;
      var state;

      if (early !== null && nowSeconds < early) {
        state = 'pre-drop';
      } else if (available === false) {
        state = 'sold-out';
      } else if (publicTs !== null && nowSeconds < publicTs) {
        state = 'early';
      } else {
        // No dates configured yet (metafields empty) also lands here —
        // treat an unconfigured drop as unrestricted rather than blocking it.
        state = 'public';
      }

      applyState(root, state);

      var target = state === 'pre-drop' ? early : state === 'early' ? publicTs : null;
      if (target !== null) {
        updateCountdowns(root, target);
      }
    }

    function pollAvailability() {
      if (!handle) return;
      fetchAvailability(handle).then(function (result) {
        if (result !== null && result !== available) {
          available = result;
          evaluate();
        }
      });
    }

    evaluate();
    pollAvailability();

    setInterval(evaluate, 1000);
    // Inventory can change without the page reloading (or via a CDN-cached
    // response), so re-check periodically instead of trusting a single read.
    setInterval(pollAvailability, INVENTORY_POLL_MS);
  }

  function requestWebPushIfNeeded() {
    // Only ever called after a successful submit — never on page load.
    if (!('Notification' in window)) return;
    if (Notification.permission !== 'default') return;
    Notification.requestPermission();
  }

  function buildKlaviyoPayload(listId, values) {
    var subscriptions = {
      email: { marketing: { consent: 'SUBSCRIBED' } }
    };
    if (values.smsConsent && values.phone) {
      subscriptions.sms = { marketing: { consent: 'SUBSCRIBED' } };
    }

    var attributes = {
      email: values.email,
      first_name: values.firstName,
      subscriptions: subscriptions
    };
    if (values.phone) attributes.phone_number = values.phone;

    return {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'DROP-01 wishlist',
          profile: { data: { type: 'profile', attributes: attributes } }
        },
        relationships: {
          list: { data: { type: 'list', id: listId } }
        }
      }
    };
  }

  var FR_MONTHS = ['jan', 'fév', 'mars', 'avr', 'mai', 'juin', 'juil', 'août', 'sept', 'oct', 'nov', 'déc'];

  function formatDropDate(unixSeconds) {
    var d = new Date(unixSeconds * 1000);
    var day = d.getDate();
    var month = FR_MONTHS[d.getMonth()];
    var hours = String(d.getHours()).padStart(2, '0');
    var minutes = String(d.getMinutes()).padStart(2, '0');
    return day + ' ' + month + ' · ' + hours + ' h ' + minutes;
  }

  function initSignupModal() {
    var dialog = document.querySelector('[data-drop-signup]');
    if (!dialog) return;

    var form = dialog.querySelector('[data-drop-signup-form]');
    var errorEl = dialog.querySelector('[data-drop-signup-error]');
    var submitBtn = dialog.querySelector('[data-drop-signup-submit]');
    var submitLabelEl = dialog.querySelector('[data-drop-signup-submit-label]');
    var doneEl = dialog.querySelector('[data-drop-signup-done]');
    var submitLabel = submitLabelEl ? submitLabelEl.textContent : '';

    // Printed dates — formatted client-side from Unix timestamps so every
    // visitor sees their own local time, and cached HTML never goes stale.
    var earlyTs = parseInt(dialog.dataset.early, 10);
    var publicTs = parseInt(dialog.dataset.public, 10);
    var earlyEl = dialog.querySelector('[data-drop-signup-date="early"]');
    var publicEl = dialog.querySelector('[data-drop-signup-date="public"]');
    if (earlyEl && earlyTs) earlyEl.textContent = formatDropDate(earlyTs);
    if (publicEl && publicTs) publicEl.textContent = formatDropDate(publicTs);

    // Gauge — reserved count is an admin-editable section setting (no live
    // Klaviyo read is possible client-side), units comes from the shop metafield.
    var reserved = parseInt(dialog.dataset.reservedCount, 10) || 0;
    var units = parseInt(dialog.dataset.units, 10) || 0;
    var gaugeFillEl = dialog.querySelector('[data-drop-signup-gauge-fill]');
    var gaugeCountEl = dialog.querySelector('[data-drop-signup-gauge-count]');
    var gaugeTotalEl = dialog.querySelector('[data-drop-signup-gauge-total]');
    var gaugePct = 0;
    if (units > 0) {
      gaugePct = Math.min(88, (reserved / units) * 100);
      if (gaugeCountEl) gaugeCountEl.innerHTML = 'Déjà <b>' + reserved + ' personnes</b> sur la liste';
      if (gaugeTotalEl) gaugeTotalEl.textContent = units + ' paires au total';
    }

    // Driven directly by JS (setInterval-stepped width), not a CSS
    // transition/animation or requestAnimationFrame — three different
    // CSS-only approaches (keyframes+var(), transition+delay,
    // transition+class-toggle) all failed to reliably produce a visible
    // fill, and requestAnimationFrame itself is suspended entirely by
    // Chrome whenever the tab isn't the focused/visible one — setInterval
    // keeps running (possibly throttled, but never frozen) regardless.
    // Timed to start once .drop-signup__gauge itself has finished fading in
    // (see its own reveal delay, --roll + 0.7s, in drop.css).
    var GAUGE_FILL_START_MS = 2700;
    var GAUGE_FILL_DURATION_MS = 1000;
    var GAUGE_FILL_STEPS = 30;

    function animateGaugeFill() {
      if (!gaugeFillEl || gaugePct <= 0) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        gaugeFillEl.style.width = gaugePct + '%';
        return;
      }
      var currentStep = 0;
      function easeOut(t) { return 1 - Math.pow(1 - t, 3); }
      var interval = setInterval(function () {
        currentStep++;
        var progress = Math.min(1, currentStep / GAUGE_FILL_STEPS);
        gaugeFillEl.style.width = (gaugePct * easeOut(progress)) + '%';
        if (progress >= 1) clearInterval(interval);
      }, GAUGE_FILL_DURATION_MS / GAUGE_FILL_STEPS);
    }

    // Guarantee the browser paints the dialog's closed state at least once
    // before showModal() flips it open, so the unroll animation actually
    // plays instead of being folded into a single first paint (mirrors the
    // reference mockup's requestAnimationFrame-gated open()). Uses setTimeout
    // rather than requestAnimationFrame — rAF is suspended entirely by
    // browsers while a tab isn't the focused/visible one, which would mean
    // the popup never opens at all if focus shifts between the click and the
    // callback; setTimeout still fires (possibly delayed) either way.
    function openSignupDialog() {
      setTimeout(function () {
        setTimeout(function () {
          dialog.showModal();
          if (gaugeFillEl) gaugeFillEl.style.width = '0%';
          setTimeout(animateGaugeFill, GAUGE_FILL_START_MS);
        }, 0);
      }, 0);
    }

    document.querySelectorAll('[data-drop-signup-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        openSignupDialog();
      });
    });

    dialog.querySelectorAll('[data-drop-signup-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { dialog.close(); });
    });

    // Click on the ::backdrop (the dialog element itself, outside its content) closes it.
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });

    var openFormBtn = dialog.querySelector('[data-drop-signup-open-form]');
    if (openFormBtn) {
      openFormBtn.addEventListener('click', function () {
        dialog.classList.add('is-form');
        var firstField = dialog.querySelector('#drop-signup-first-name');
        if (firstField) setTimeout(function () { firstField.focus(); }, 400);
      });
    }

    var closeFormBtn = dialog.querySelector('[data-drop-signup-close-form]');
    if (closeFormBtn) {
      closeFormBtn.addEventListener('click', function () {
        dialog.classList.remove('is-form');
      });
    }

    // Design/QA shortcut: ?drop_signup=open opens the popup on load, no console needed.
    if (new URLSearchParams(window.location.search).get('drop_signup') === 'open') {
      openSignupDialog();
    }

    // Password page: the popup is the only way for a locked-out visitor to
    // join the wishlist, so it opens on its own instead of waiting for a click.
    if ('dropSignupAutoopen' in dialog.dataset) {
      openSignupDialog();
    }

    function showError(message) {
      errorEl.textContent = message;
      errorEl.hidden = false;
    }

    function clearError() {
      errorEl.hidden = true;
      errorEl.textContent = '';
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      clearError();

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      var companyId = dialog.dataset.klaviyoCompanyId;
      var listId = dialog.dataset.klaviyoListId;
      if (!companyId || !listId) {
        showError('Configuration Klaviyo manquante.');
        return;
      }

      var values = {
        firstName: form.first_name.value.trim(),
        email: form.email.value.trim(),
        phone: form.phone.value.trim(),
        smsConsent: form.sms_consent.checked
      };

      submitBtn.disabled = true;
      if (submitLabelEl) submitLabelEl.textContent = '...';

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2026-07-15' },
        body: JSON.stringify(buildKlaviyoPayload(listId, values))
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Klaviyo request failed: ' + response.status);
          dialog.classList.add('is-done');
          if (doneEl) doneEl.hidden = false;
          requestWebPushIfNeeded();
        })
        .catch(function () {
          // Never show success on failure — a false success means a customer
          // who never gets their link on drop day.
          showError(dialog.dataset.errorText || 'Quelque chose a bloqué. Réessaie, ou écris-nous si ça persiste.');
        })
        .finally(function () {
          submitBtn.disabled = false;
          if (submitLabelEl) submitLabelEl.textContent = submitLabel;
        });
    });
  }

  var PROMO_SEEN_KEY = 'dropPromoSeen';

  function initPromoPopup() {
    var dialog = document.querySelector('[data-drop-promo]');
    if (!dialog) return;

    var publicTs = parseInt(dialog.dataset.public, 10);
    var dateEl = dialog.querySelector('[data-drop-promo-date]');
    if (dateEl && publicTs) dateEl.textContent = formatDropDate(publicTs);

    function openPromoDialog() {
      setTimeout(function () {
        setTimeout(function () { dialog.showModal(); }, 0);
      }, 0);
    }

    dialog.querySelectorAll('[data-drop-promo-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        dialog.close();
        try { sessionStorage.setItem(PROMO_SEEN_KEY, '1'); } catch (e) {}
      });
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) {
        dialog.close();
        try { sessionStorage.setItem(PROMO_SEEN_KEY, '1'); } catch (e) {}
      }
    });

    // Design/QA shortcut: ?drop_promo=open bypasses the session flag and the
    // early/public state check, same spirit as ?drop_signup=open above.
    if (new URLSearchParams(window.location.search).get('drop_promo') === 'open') {
      openPromoDialog();
      return;
    }

    var alreadySeen;
    try { alreadySeen = sessionStorage.getItem(PROMO_SEEN_KEY) === '1'; } catch (e) { alreadySeen = false; }
    if (alreadySeen) return;

    // Only worth showing once the drop is actually purchasable — offering a
    // 2-for-1 bundle before anything can be bought, or after sell-out, makes
    // no sense. State comes from the shared drop-root machine (initRoot ran
    // on this same element already, since it carries the .drop-root class).
    var state = dialog.dataset.dropCurrentState;
    if (state !== 'early' && state !== 'public') return;

    function openNow() {
      try { sessionStorage.setItem(PROMO_SEEN_KEY, '1'); } catch (e) {}
      openPromoDialog();
    }

    // S'ouvre à la fin de la cinématique d'intro du thème, au même moment que
    // l'écran d'entrée (#entry-gate) : les deux écoutent 'splashscreen:dismissed'.
    // Quand la cinématique a déjà été vue dans la session, le thème envoie cet
    // événement dès le début du <body>, avant que ce script (defer) ne tourne :
    // on ouvre alors tout de suite. Idem si la page n'a pas de cinématique.
    var splashDone = false;
    try { splashDone = sessionStorage.getItem('splashSeen') === '1'; } catch (e) {}
    if (splashDone || !document.getElementById('splash-screen')) {
      openNow();
    } else {
      document.addEventListener('splashscreen:dismissed', openNow, { once: true });
    }
  }

  var LEAF_SHAPES = [
    'M12 1.6 L13.7 6 L17.6 4.6 L16.7 8.7 L21 8 L18.1 11.1 L22.2 12.5 L18.3 14 L20.1 17.3 L16 16.7 L15.6 20.1 L12.7 17.5 L12 22.4 L11.3 17.5 L8.4 20.1 L8 16.7 L3.9 17.3 L5.7 14 L1.8 12.5 L5.9 11.1 L3 8 L7.3 8.7 L6.4 4.6 L10.3 6 Z',
    'M8 16.4 C 5.2 10.2 10.4 4.2 19.8 3.8 C 20.3 13.4 14.6 18.3 8 16.4 Z',
    'M12 2.2 C 18.4 7 18.8 14.2 12 19 C 5.2 14.2 5.6 7 12 2.2 Z'
  ];
  var LEAF_COLORS = ['#7A2A0C', '#5A1E08', '#9C3B12', '#E3B04B', '#F0CF80', '#B8541C'];

  function randBetween(a, b) { return a + Math.random() * (b - a); }
  function pickOne(arr) { return arr[Math.floor(Math.random() * arr.length)]; }

  function makePasswordHeroLeaves(box) {
    box.innerHTML = '';
    var count = window.innerWidth < 600 ? 10 : 16;
    for (var i = 0; i < count; i++) {
      var size = randBetween(18, 42);
      var fall = randBetween(12, 22);
      var leaf = document.createElement('div');
      leaf.className = 'drop-password-hero__leaf';
      leaf.style.left = randBetween(-4, 100) + 'vw';
      leaf.style.animationDuration = fall + 's';
      leaf.style.animationDelay = (-randBetween(0, fall)) + 's';

      var sway = document.createElement('div');
      sway.className = 'drop-password-hero__leaf-sway';
      sway.style.animationDuration = randBetween(2.6, 4.8) + 's';
      sway.innerHTML = '<svg width="' + size + '" height="' + size + '" viewBox="0 0 24 24" style="animation-duration:' + randBetween(1.4, 2.8) + 's"><path d="' + pickOne(LEAF_SHAPES) + '" fill="' + pickOne(LEAF_COLORS) + '"/></svg>';

      leaf.appendChild(sway);
      box.appendChild(leaf);
    }
  }

  function initPasswordHero() {
    var root = document.querySelector('[data-drop-password-hero]');
    if (!root) return;

    var leavesBox = root.querySelector('[data-drop-password-leaves]');
    if (leavesBox) makePasswordHeroLeaves(leavesBox);

    // setTimeout, not requestAnimationFrame — rAF is suspended entirely by
    // browsers while a tab isn't the focused/visible one, which would leave
    // the whole hero stuck invisible if focus shifts during load (see the
    // same reasoning on openSignupDialog above).
    var start = function () {
      setTimeout(function () { root.classList.add('is-go'); }, 0);
    };
    if (document.readyState === 'complete') {
      start();
    } else {
      window.addEventListener('load', start);
    }
  }

  function init() {
    document.querySelectorAll('.drop-root').forEach(initRoot);
    initSignupModal();
    initPromoPopup();
    initPasswordHero();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
